/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Disabled } from './Disabled';
import { Enabled } from './Enabled';
import { EnabledEditor } from './EnabledEditor';
import { EnabledWebhook } from './EnabledWebhook';
const UploadConfigurationParser = /* #__PURE__ */ parsers.object([
    [
        'editor',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledEditor],
            ['disabled', Disabled],
        ]),
    ],
    [
        'files',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', Enabled],
            ['disabled', Disabled],
        ]),
    ],
    [
        'webhook',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledWebhook],
            ['disabled', Disabled],
        ]),
    ],
]);
export class UploadConfiguration extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UploadConfigurationParser.decode(input).map(res => new UploadConfiguration(res));
    }
    static unsafeDecode(input) {
        return UploadConfiguration.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UploadConfigurationParser.encode(data);
    }
    static schema() {
        return UploadConfigurationParser.schema();
    }
}
